import { Location, useLocation, useNavigate } from "react-router-dom";

import { isActivatedDossierPage, isEmployerPage } from "../../helpers/dossiers";
import { removeModalParams } from "../../helpers/routes";
import ContactCorporateSupport from "../components/ContactCorporateSupport";
import ContactDriverSupport from "../components/ContactDriverSupport";
import ContactSalesOwner from "../components/ContactSalesOwner";

const ContactHelp = ({ appLocation }: { appLocation: Location<unknown> }) => {
  const navigate = useNavigate();
  const isActivatedDossier = isActivatedDossierPage();
  const isEmployer = isEmployerPage();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const regardingOpportunityId = searchParams.get("modal.opportunityId");

  const onSubmit = async () => {
    navigate(
      `${appLocation.pathname}?${removeModalParams(searchParams).toString()}`,
      {
        replace: true,
      }
    );
  };

  let content;
  if (isEmployer) {
    content = (
      <ContactCorporateSupport
        onSubmit={onSubmit}
        regardingOpportunityId={regardingOpportunityId || undefined}
      />
    );
  } else if (isActivatedDossier) {
    content = (
      <ContactDriverSupport
        onSubmit={onSubmit}
        regardingOpportunityId={regardingOpportunityId || undefined}
      />
    );
  } else {
    content = (
      <ContactSalesOwner
        onSubmit={onSubmit}
        regardingOpportunityId={regardingOpportunityId || undefined}
      />
    );
  }

  return <>{content}</>;
};

export default ContactHelp;
